import { request, loginIfNeeded, closeAppWebView } from '@lib/bridge.js';
import { getCookieValue } from '@lib/utils.js';

const timerPromise = (dur = 10000) => (new Promise(function(resolve) {
    setTimeout(resolve, dur, { error_msg: "请求超时，请检查网络连接或稍后再试", result: 500 });
}));
const loginPromise = () => (new Promise((resolve, reject) => {
    loginIfNeeded(info => {
        info = JSON.parse(info);
        if (!info.result) {
            setTimeout(() => {
                closeAppWebView();
            }, 1000);
            reject();
        } else {
            resolve();
        }
    });
}));

export const fetchData = (params = {}, config = {}) => {
    const func = config.requestBridge || request;
    const { timeout = 30000, delay = 0, checkLogin = false } = config;
    console.log("fetchData config:", JSON.stringify(config));
    const fetchPromise = () => (new Promise((resolve) => {
        const t0 = Date.now();
        func(params, res => { 
            const t1 = Date.now();
            const d = Math.max(delay - (t1 - t0), 0);
            setTimeout(() => {
                if (res.result < 0) {
                    resolve({ error_msg: "网络问题，请检查网络或稍后再试", result: res.result }); 
                } else {
                    resolve(res); 
                }
            }, d);
        });
    }));
    const fasterPromise = () => Promise.race([fetchPromise(), timerPromise(timeout)]);
    if (checkLogin) {
        if (!getCookieValue('userId')) {
            return loginPromise().then(() => {
                return fasterPromise();
            }, () => {
                return Promise.resolve({ error_msg: "用户未登录", result: 100 });
            });
        }
    }
    return fasterPromise();
};

function joinArray(arr1, arr2) {
    const res = [];
    for (let i = 0; i < arr1.length; i++) {
        arr1[i] && res.push(arr1[i]);
        arr2[i] && res.push(arr2[i]);
    }
    return res.join('');
}

export const GET = (string, ...val) => {
    return async params => {
        return await fetchData({
            method: 'GET',
            urlString: joinArray(string, val),
            data: {
                ...params,
            },
        });
    };
};

export const POST = (string, ...val) => {
    return async ({fake_user_id, ...params}) => {
        return await fetchData({
            method: 'POST',
            urlString: joinArray(string, val),
            data: {
                ...params,
            },
        });
    };
};
